export default "__VITE_ASSET__WdKH$HNh__"